import { ToEntity } from 'core/common/mappers';
import { UserProfile } from '../entities';
import { UserProfileDto } from '../services/dto';

export class UserProfileDtoMapper implements ToEntity<UserProfile, UserProfileDto> {
  toEntity(dto: UserProfileDto): UserProfile {
    return {
      ...dto.funnel_interaction.quiz_data,
      email: dto.funnel_interaction.email,
      date: dto.funnel_interaction.quiz_data.birth_date,
    };
  }
}
